import type { Section } from '@common/formEngine/formEngine.types';
import { AssetCategory } from '@common/enums';
import { pdfExtensions } from '@common/utils/fileExtensions';
import { getProcessActivityAssetsSchema, type ProcessActivityAsset } from '@common/validation/processActivityAsset';

export type HolterAnalysisReportData = {
    assets: ProcessActivityAsset[];
};

export const holterAnalysisReportSections: Section<HolterAnalysisReportData>[] = [
    {
        fields: [
            {
                acceptExtensions: pdfExtensions,
                draftSchema: getProcessActivityAssetsSchema({ category: AssetCategory.customcontroldata }),
                finalSchema: getProcessActivityAssetsSchema({ category: AssetCategory.customcontroldata, min: 1 }),
                isRequired: true,
                key: 'assets',
                label: 'Report',
                type: 'assets',
            },
        ],
    },
];
